import { formAddToCartPayload } from "./Helper.js";
import { TaggingConstant } from "./TaggingConstant.js";
const isMybizMfeOmni = window.zincTag && typeof window.zincTag == 'object' && window['mbtGlobal']?.mfeConfig?.nseMFEEnabled;
const pageData = TaggingConstant["page"];

export const pageTracking = (page,subFlow="") => {
    if (isMybizMfeOmni) {
		window['zincTag'].push({
            task: "definePage",
            params: {
                type:"mybizreact.base",
                pageName:pageData[page]?.pageName,
                flow:"",
                channel:"Shop",
                subFlow:subFlow
            }
        });
    }
}

export const pegaImpressionTracking = (pegaDataTrack) => {
    if (isMybizMfeOmni) {
			if (pegaDataTrack && pegaDataTrack["pegaGWTaggingData"] !== null) {
                    window['zincTag'].push({
                      task: "impression",
                      params: {
                          list:pegaDataTrack["pegaGWTaggingData"],
                          data : {
                              utils : {
                                athenaSession : pegaDataTrack["pegaGwInteractionId"],
                                recommendationModel:pegaDataTrack["pegaGwModelName"]||""
                              },
                              target : {
                                  assetAttributes:pegaDataTrack["pegaGwDecisioningPath"]  //Pega / PZAI
                              }
                          }
                      }
                  });
              }
    }
}

export const trackPDPPageInfo = (page,pdpMockData) => {
    if (isMybizMfeOmni) {
        window['zincTag'].push({
                        task: "definePage",
                        params: {
                            type : "mybizreact.PDP",
                            src : pdpMockData,
                            pageName : pageData[page]?.pageName, //dynamic
                            productType : page === "accessoryPdp" ? "accessory" : 'device',
                            flow:"", //dynamic
                            channel:"Order", //dynamic
                            displayChannel:""
                        }
        })
    }
}


export const trackAddtocart = (productType="",addtocartMock) => {
    if (isMybizMfeOmni) {
        let productsList = {device: [],plan: [],feature: [],software:[],accessory:[]};
        let products = {};

        if (productsList.hasOwnProperty(productType)) {
            productsList[productType] = addtocartMock;
            products = productsList;
        } else {
            products = addtocartMock;
        }
        
        window['zincTag'].push({
            task: "mybizreact.addToCart",
            params: {
                openCart: addtocartMock?.isOpenCart, // first product to cart
                src: products //dynamic based on the API
            }
        });
    }
}

export const trackShoppingCartOmni = (pageName,cartMockData) => {
    if (isMybizMfeOmni && window['zincTag']) {
       window['zincTag'].push({
            task: "definePage",
            params: {
                type : "mybizreact.Cart",//Static,
                event:pageData[pageName]?.eventName,//'scView',//Static,
                cartSrc : cartMockData, // dynamic fethCartAPi response
                pageName : pageData[pageName]?.pageName, //dynamic based on the techspec
                flow:"", //dynamic based on the techspec
                channel:"order",//dynamic based on the techspec
            }
        })
    }
}
